// Bandeau « ton essai se termine bientôt » sur l'accueil (27/10/2026).
// Visible pendant les ALERTE_FIN_ESSAI_JOURS derniers jours de l'essai (cf. messageFinEssai).
// Avant ce bandeau, rien ne prévenait : la cliente découvrait le mur d'abonnement une fois
// l'essai terminé. Le bouton mène à Réglages, où se trouvent les formules.

import { useAuth } from '@/lib/auth'
import { messageFinEssai } from '@/lib/abonnement'

export default function BandeauFinEssai({ onVoirFormules }: { onVoirFormules: () => void }) {
  const { user } = useAuth()
  const message = user ? messageFinEssai(user) : null
  if (!message) return null

  return (
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900 shadow-sm">
      <p>
        <span aria-hidden="true">⏳ </span>
        <span className="font-semibold">{message}</span> Choisis ta formule pour continuer à créer et
        modifier : tes formules, lots et factures sont conservés.
      </p>
      <button
        type="button"
        onClick={onVoirFormules}
        className="shrink-0 rounded-lg bg-bdspIndigo px-3 py-1.5 text-sm font-semibold text-white transition hover:opacity-90"
      >
        Voir les formules
      </button>
    </div>
  )
}
